var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaisonFichier8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63.81 63.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Nouvelle_nuance_de_motif_4);}.cls-2{fill:none;}.cls-3{fill:#d72616;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "Nouvelle_nuance_de_motif_4",
    x: 0,
    y: 0,
    width: 94.07,
    height: 94.07,
    patternTransform: "translate(353.29 50.62) scale(3.96)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 94.07 94.07"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 94.07,
    height: 94.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    width: 94.07,
    height: 94.07
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.81 63.88 63.81 25.07 31.91 0 0 25.07 0 63.88 63.81 63.88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaisonFichier8);
export default __webpack_public_path__ + "static/media/MAISONFichier 8.f49c61ac59f05c07971bff8120d02503.svg";
export { ForwardRef as ReactComponent };